// extracted by mini-css-extract-plugin
module.exports = {"container":"horseRacingHeader_container__6IBcC","title":"horseRacingHeader_title__a0fsM","timeContainer":"horseRacingHeader_timeContainer__rAY8v"};